import gql from 'graphql-tag';
import { SURVEY_TYPE_CONNECTION } from './SurveyTypeConnection.gql';

export const ALL_ORG_SURVEY_BY_TEAM_QUERY = gql`
  ${SURVEY_TYPE_CONNECTION}
  query orgSurveyByTeam($id: ID!, $before: String, $after: String, $first: Int, $last: Int) {
    orgSurveyByTeam(id: $id, before: $before, after: $after, first: $first, last: $last) {
      ...SurveyTypeConnection
    }
  }
`;
